import React from "react";
import { MistyLogo } from "./ImageSlot";

export const Footer = ({ onOpenPolicy }) => {
  const year = new Date().getFullYear();
  const scrollTo = (href) => (e) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      className="bg-misty-base border-t border-white/5 pt-16 pb-6 px-6 md:px-12"
      data-testid="footer"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-12 border-b border-white/5">
          <div className="flex flex-col gap-4">
            <MistyLogo size="md" testId="footer-logo" />
            <p className="text-misty-muted text-sm leading-relaxed max-w-xs mt-2">
              Premium vape distribution serving distributors, retailers, and
              consumers across South Africa.
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <p className="text-misty-dim text-[10px] tracking-[0.4em] uppercase">
              Products
            </p>
            <ul className="flex flex-col gap-2.5">
              <li>
                <a
                  href="#products"
                  onClick={scrollTo("#products")}
                  className="text-misty-text hover:text-misty-steel transition-colors text-sm"
                  data-testid="footer-product-goldbar600"
                >
                  Gold Bar 600
                </a>
              </li>
              <li>
                <a
                  href="#products"
                  onClick={scrollTo("#products")}
                  className="text-misty-text hover:text-misty-steel transition-colors text-sm"
                  data-testid="footer-product-goldbar247"
                >
                  Gold Bar 247
                </a>
              </li>
              <li>
                <a
                  href="#products"
                  onClick={scrollTo("#products")}
                  className="text-misty-text hover:text-misty-steel transition-colors text-sm"
                  data-testid="footer-product-titanpro"
                >
                  Titan Pro
                </a>
              </li>
              <li>
                <a
                  href="#products"
                  onClick={scrollTo("#products")}
                  className="text-misty-text hover:text-misty-steel transition-colors text-sm"
                  data-testid="footer-product-titanpropod"
                >
                  Titan Pro Pod
                </a>
              </li>
            </ul>
          </div>

          <div className="flex flex-col gap-4">
            <p className="text-misty-dim text-[10px] tracking-[0.4em] uppercase">
              Legal
            </p>
            <ul className="flex flex-col gap-2.5">
              <li>
                <button
                  onClick={() => onOpenPolicy("privacy")}
                  className="text-misty-text hover:text-misty-steel transition-colors text-sm text-left"
                  data-testid="footer-policy-privacy"
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button
                  onClick={() => onOpenPolicy("terms")}
                  className="text-misty-text hover:text-misty-steel transition-colors text-sm text-left"
                  data-testid="footer-policy-terms"
                >
                  Terms of Use
                </button>
              </li>
              <li>
                <button
                  onClick={() => onOpenPolicy("age")}
                  className="text-misty-text hover:text-misty-steel transition-colors text-sm text-left"
                  data-testid="footer-policy-age"
                >
                  Age Restriction Policy
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row gap-4 md:gap-8 md:items-center justify-between">
          <p className="text-misty-dim text-[10px] tracking-[0.25em] uppercase">
            © {year} Misty Distribution. All rights reserved.
          </p>
          <p className="text-misty-dim text-[10px] tracking-[0.25em] uppercase max-w-xl">
            <span className="text-misty-warn">⚠ Warning:</span> This product
            contains nicotine. Nicotine is an addictive chemical. Adults 18+
            only.
          </p>
        </div>
      </div>
    </footer>
  );
};
